// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BrandBox{display:flex;flex-direction:column;height:100%;justify-content:center;text-align:center}@media print{.BrandBox{padding:0}}.BrandBox__link{padding:1rem}@media(min-width:768px){.BrandBox__link{padding:2rem}}.BrandBox__image{height:auto;max-height:12rem;max-width:50vw;width:auto}@media(min-width:768px){.BrandBox__image{max-width:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
